import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  html, body {
    overflow-x: hidden;
    width: 100%;
    max-width: 100%;
    position: relative; 
    font-family: 'Sora', sans-serif;
  }
  
  body {
    background-color: #f5f5f5;
    min-height: 100vh; 
  }
  
  a {
    text-decoration: none;
  }
  
  button {
    cursor: pointer;
    font-family: 'Sora', sans-serif;
  }
  
  /* regras para dispositivos móveis */
  @media (max-width: 768px) {
    #root {
      overflow-x: hidden;
      width: 100%;
    }
  }
`;

export default GlobalStyle;